"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpReportFilters = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var react_i18next_1 = require("react-i18next");
var curriculum_helper_1 = require("../../../api/helpers/curriculum.helper");
var DpFilterDropdown_1 = require("../DropdownFilter/DpFilterDropdown");
var DpReportFilters_styled_1 = require("./DpReportFilters.styled");
var DpReportFilters = function (_a) {
    // --------------------------- Context
    var filterByAssessmentHandler = _a.filterByAssessmentHandler, filterByModuleHandler = _a.filterByModuleHandler, filterBySectionHandler = _a.filterBySectionHandler, curriculums = _a.curriculums, assessments = _a.assessments, filterCriteria = _a.filterCriteria, generateHandler = _a.generateHandler, disabledSectionFilter = _a.disabledSectionFilter;
    var _b = (0, react_1.useState)({
        sectionsOptions: [],
        modulesOptions: [],
        assessmentsOptions: [],
    }), filters = _b[0], setFilters = _b[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var loadAssessments = function (assessmentList, modulesSelected, sectionsSelected) {
        var modulesIds = modulesSelected.map(function (module) { return module.id; });
        var sectionsIds = sectionsSelected.map(function (section) { return section.id; });
        var assessmentTemplatesLoaded = assessmentList
            .filter(function (_a) {
            var assessmentTemplate = _a.assessmentTemplate, assessmentClass = _a.assessmentClass;
            return modulesIds.includes(assessmentTemplate.module) &&
                sectionsIds.includes(assessmentClass.id);
        })
            .map(function (_a) {
            var assessmentTemplate = _a.assessmentTemplate;
            return assessmentTemplate;
        });
        return (0, uniqBy_1.default)(assessmentTemplatesLoaded, 'id');
    };
    var loadModules = (0, react_1.useCallback)(function () {
        var grades = (0, curriculum_helper_1.getGradesFromCurriculums)(curriculums);
        return (0, curriculum_helper_1.getModulesFromGrades)(grades);
    }, [curriculums]);
    var getFilterDropDownOptions = function (elements, criteria) {
        return elements.map(function (element) { return ({
            id: element.id,
            title: element.name ? element.name : element.title,
            selected: criteria.includes(element.id),
        }); });
    };
    var getSelectedOptions = function (elements, criteria) {
        return elements.filter(function (_a) {
            var id = _a.id;
            return criteria.includes(id);
        });
    };
    // Load filters values
    var setFiltersOptions = (0, react_1.useCallback)(function (criteria) { return __awaiter(void 0, void 0, void 0, function () {
        var sectionsOptions, modulesOptions, assessmentsOptions, selectedSections, selectedModules, sectionsLoaded, filteredSections, filteredModules, filteredAssessments;
        return __generator(this, function (_a) {
            sectionsOptions = [];
            modulesOptions = [];
            assessmentsOptions = [];
            selectedSections = [];
            selectedModules = [];
            sectionsLoaded = assessments.map(function (assessment) { return assessment.assessmentClass; });
            filteredSections = (0, uniqBy_1.default)(sectionsLoaded, 'id');
            sectionsOptions = sectionsOptions.concat(getFilterDropDownOptions(filteredSections, criteria.sections));
            selectedSections = selectedSections.concat(getSelectedOptions(filteredSections, criteria.sections));
            // Getting modules
            if (!(0, isEmpty_1.default)(selectedSections)) {
                filteredModules = loadModules();
                modulesOptions = modulesOptions.concat(getFilterDropDownOptions(filteredModules, criteria.modules));
                selectedModules = selectedModules.concat(getSelectedOptions(filteredModules, criteria.modules));
            }
            // Getting assessments templates
            if (!(0, isEmpty_1.default)(selectedModules)) {
                filteredAssessments = loadAssessments(assessments, selectedModules, selectedSections);
                assessmentsOptions = assessmentsOptions.concat(getFilterDropDownOptions(filteredAssessments, criteria.assessments));
            }
            setFilters({
                sectionsOptions: sectionsOptions,
                modulesOptions: modulesOptions,
                assessmentsOptions: assessmentsOptions,
            });
            return [2 /*return*/];
        });
    }); }, [loadModules, assessments]);
    // Click event for Generate Report button
    var generateReport = function (criteria) { return function (e) {
        generateHandler(criteria);
    }; };
    // ------------------------------- Methods
    (0, react_1.useEffect)(function () {
        setFiltersOptions(filterCriteria);
    }, [filterCriteria, setFiltersOptions]);
    return ((0, jsx_runtime_1.jsxs)(DpReportFilters_styled_1.StyledReportFilters, { children: [(0, jsx_runtime_1.jsx)(DpFilterDropdown_1.DpFilterDropdown, { classes: "section-filter", placeholder: t('reportFilters.section'), options: filters.sectionsOptions, selectHandler: filterBySectionHandler, disabled: disabledSectionFilter, id: "reports-filters-section-filter" }), (0, jsx_runtime_1.jsxs)("div", { className: "module-filter", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "reports-filters-modules-filter", children: t('reportFilters.resultsFrom') }), (0, jsx_runtime_1.jsx)(DpFilterDropdown_1.DpFilterDropdown, { classes: "modules-filter", placeholder: t('reportFilters.module'), options: filters.modulesOptions, selectHandler: filterByModuleHandler, id: "reports-filters-modules-filter" })] }), (0, jsx_runtime_1.jsx)(DpFilterDropdown_1.DpFilterDropdown, { classes: "assessment-filter", placeholder: t('reportFilters.assessment'), options: filters.assessmentsOptions, selectHandler: filterByAssessmentHandler, id: "reports-filters-assessment-filter" }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { className: "generate-btn ".concat(!filterCriteria.hasAssessments() ? 'disabled' : ''), onClick: generateReport(filterCriteria), children: t('reportFilters.generateReport') })] }));
};
exports.DpReportFilters = DpReportFilters;
exports.default = exports.DpReportFilters;
